<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center" no-gutters>
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-form @submit.prevent="submit">
          <v-card class="elevation-2" :loading="sending ? 'primary' : false">
            <v-card-title>Sign Up</v-card-title>
            
            <v-card-text>
              <v-text-field label="Summoner Name" type="text" v-model="summonerName" :error-messages="summonerNameErrors" :prepend-icon="$vuetify.breakpoint.smAndUp ? 'mdi-account' : undefined"/>
              
              <v-select class="mt-1 pt-3" label="Region" solo v-model="region" :items="regions" :error-messages="regionErrors" :prepend-icon="$vuetify.breakpoint.smAndUp ? 'mdi-earth' : undefined"/>
              
              <v-text-field label="Email" type="email" v-model="email" :error-messages="emailErrors" :prepend-icon="$vuetify.breakpoint.smAndUp ? 'mdi-email' : undefined"/>
              <v-text-field label="Password" type="password" v-model="password" :error-messages="passwordErrors" :prepend-icon="$vuetify.breakpoint.smAndUp ? 'mdi-lock' : undefined"/>
              <v-text-field label="Repeat Password" type="password" v-model="repeatPassword" :error-messages="repeatPasswordErrors" :prepend-icon="$vuetify.breakpoint.smAndUp ? 'mdi-lock' : undefined"/>
              
              <v-checkbox label="I hereby confirm that I am atleast 18 years old and agree to the privacy policy." color="primary" v-model="consent" :error-messages="consentErrors"/>
            </v-card-text>

            <v-card-actions>
              <v-spacer/>

              <v-btn color="primary" type="submit">Sign Up</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, email, minLength, sameAs } from 'vuelidate/lib/validators';

export default {
  name: 'sign-up',
  mixins: [validationMixin],
  validations: {
    summonerName: { required },
    region: { required },
    email: { required, email },
    password: { required, minLength: minLength(6) },
    repeatPassword: { required, sameAsPassword: sameAs('password') },
    consent: {
      checked: value => value === true
    }
  },
  data: () => ({
    summonerName: '',
    region: '',
    email: '',
    password: '',
    repeatPassword: '',
    consent: false,
    sending: false,
    regions: [{
        value: 'euw1',
        text: 'Europe West'
      },
      {
        value: 'na1',
        text: 'North America'
      }
    ]
  }),
  computed: {
    summonerNameErrors() {
      const errors = [];

      if(!this.$v.summonerName.$dirty) {
        return errors;
      }

      !this.$v.summonerName.required && errors.push('Summoner name is required');

      return errors;
    },
    regionErrors() {
      const errors = [];

      if(!this.$v.region.$dirty) {
        return errors;
      }

      !this.$v.region.required && errors.push('Region is required');

      return errors;
    },
    emailErrors() {
      const errors = [];

      if(!this.$v.email.$dirty) {
        return errors;
      }

      !this.$v.email.email && errors.push('Must be a valid email');
      !this.$v.email.required && errors.push('Email is required');

      return errors;
    },
    passwordErrors() {
      const errors = [];

      if(!this.$v.password.$dirty) {
        return errors;
      }

      !this.$v.password.required && errors.push('Password is required');
      !this.$v.password.minLength && errors.push('Password must be at least 6 characters long');

      return errors;
    },
    repeatPasswordErrors() {
      const errors = [];

      if(!this.$v.repeatPassword.$dirty) {
        return errors;
      }

      !this.$v.repeatPassword.required && errors.push('Repeat password is required');
      !this.$v.repeatPassword.sameAsPassword && errors.push('Passwords must be identical');

      return errors;
    },
    consentErrors() {
      const errors = [];

      if(!this.$v.consent.$dirty) {
        return errors;
      }

      !this.$v.consent.checked && errors.push('You must agree to the privacy policy');

      return errors;
    }
  },
  methods: {
    submit() {
      this.$v.$touch();

      if(!this.$v.$invalid) {
        this.signUp();
      }
    },
    signUp() {
      this.sending = true;
      
      this.$store.dispatch('signUp', {
        summonerName: this.summonerName,
        region: this.region,
        email: this.email,
        password: this.password,
        consent: this.consent
      })
      .then(() => {
        this.sending = false;

        this.$router.go(-1);
      })
      .catch(() => {
        this.sending = false;
      });
    }
  }
}
</script>